import { m } from 'framer-motion'
// @mui
import { styled } from '@mui/material/styles'
import { Box, Container, Typography, Divider, Grid, Card } from '@mui/material'
import { MotionViewport, varFade } from '../../components/animate'
import Iconify from '../../components/iconify'
import { AWS_CDN_DOMAIN } from 'src/config-global'
// components
import Image from 'src/components/image'

const StyledRoot = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(10, 0),
  [theme.breakpoints.up('md')]: {
    height: '115vh', // Desktop 80vh, mobile 100vh
    padding: 0,
  },
  height: 'auto',
  paddingLeft: '20px',
  paddingTop: '40px',
  '&::after': {
    content: '""',
    position: 'absolute',
    left: 0,
    bottom: 0,
    right: 0,
    height: '10px',
    // backgroundColor: '#fff',
  },
}))

const StyledBackground = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0, // change this value as needed
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: -1,
  backgroundImage: `url(${AWS_CDN_DOMAIN + '/frontend-files/images/medium/background-lines.webp'})`,
  backgroundSize: 'cover',
  backgroundPosition: 'top',

  // Make image top fading in white gradient
  '&::before': {
    content: "''",
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '100%',
    background: 'linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.8) 100%)',
  },
}))

const svgImg = '/assets/svg/dashbaord-screenshot.svg'

// ----------------------------------------------------------------------

export default function HomeContainerTracking() {
  return (
    <StyledRoot
      sx={{
        backgroundImage: `url(${svgImg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'left bottom',
        opacity: 0.8,
      }}
    >
      <StyledBackground />
      <Container component={MotionViewport}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={7}>
            {' '}
            <Box
              gap={{ xs: 3, lg: 5 }}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',
                justifyContent: 'left',
                textAlign: 'left',
                mt: 5,
                // color: 'common.white',
                maxWidth: 610,
              }}
            >
              {/* Display svgImg  */}
              <m.div>
                <img src={svgImg} alt="Dashboard Screenshot" />
              </m.div>
            </Box>
          </Grid>
          <Grid item xs={12} md={5}>
            {' '}
            <Box
              gap={{ xs: 3, lg: 5 }}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'left',
                justifyContent: 'left',
                textAlign: 'left',
                mt: 5,
                // color: 'common.white',
                maxWidth: 600,
              }}
            >
              {/* Image  */}
              <Image src={AWS_CDN_DOMAIN + '/frontend-files/images/medium/white-container.webp'} alt="container tracking" />
            </Box>
          </Grid>
        </Grid>

        <Box
          gap={{ xs: 3, lg: 5 }}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            mt: 12,
            // color: 'common.white',
            maxWidth: 1200,
          }}
        >
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Card
                sx={{
                  p: 3,
                  borderRadius: '12px',

                  boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 12px 0 rgba(0, 0, 0, 0.1)',
                }}
              >
                <Iconify
                  icon="carbon:ibm-cloud-pak-manta-automated-data-lineage"
                  width={40}
                  spacing={2}
                  sx={{ color: '#000', transition: 'color 0.3s ease-in-out' }}
                  onMouseEnter={(e) => (e.target.style.color = '#000')}
                  onMouseLeave={(e) => (e.target.style.color = '#000')}
                />
                <m.div variants={varFade().inUp}>
                  <Typography variant="h5" sx={{ textAlign: 'center', lineHeight: 1, m: 3 }}>
                    No more spreadsheets.
                  </Typography>
                  <Divider sx={{ m: 1 }} />
                </m.div>

                <m.div variants={varFade().inUp}>
                  <Typography variant="body" sx={{ textAlign: 'center', lineHeight: 2, pt: 0 }}>
                    Just import a list of shipment numbers by CSV or API - that is all Cubistics needs to start monitoring your containers.
                  </Typography>
                </m.div>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3, borderRadius: '12px', boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 12px 0 rgba(0, 0, 0, 0.1)' }}>
                <Iconify
                  icon="icon-park:api-app"
                  width={40}
                  spacing={2}
                  sx={{ color: '#000', transition: 'color 0.3s ease-in-out' }}
                  onMouseEnter={(e) => (e.target.style.color = '#000')}
                  onMouseLeave={(e) => (e.target.style.color = '#000')}
                />
                <m.div variants={varFade().inUp}>
                  <Typography variant="h5" sx={{ textAlign: 'center', lineHeight: 1, m: 3 }}>
                    Everything under control.
                  </Typography>
                  <Divider sx={{ m: 1 }} />
                </m.div>

                <m.div variants={varFade().inUp}>
                  <Typography variant="body" sx={{ textAlign: 'center', lineHeight: 2, pt: 0 }}>
                    See the overall container shipments statuses or explore a detailed information about a specific ones.
                  </Typography>
                </m.div>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card sx={{ p: 3, borderRadius: '12px', boxShadow: '0 0 0 1px rgba(0, 0, 0, 0.1), 0 4px 12px 0 rgba(0, 0, 0, 0.1)' }}>
                <Iconify
                  icon="simple-line-icons:like"
                  width={40}
                  spacing={2}
                  sx={{ color: '#000', transition: 'color 0.3s ease-in-out' }}
                  onMouseEnter={(e) => (e.target.style.color = '#000')}
                  onMouseLeave={(e) => (e.target.style.color = '#000')}
                />
                <m.div variants={varFade().inUp}>
                  <Typography variant="h5" sx={{ textAlign: 'center', lineHeight: 1, m: 3 }}>
                    See what matters now.
                  </Typography>
                  <Divider sx={{ m: 1 }} />
                </m.div>

                <m.div variants={varFade().inUp}>
                  <Typography variant="body" sx={{ textAlign: 'center', lineHeight: 2, pt: 0 }}>
                    Get a full overview of things that need your attention today - what's arriving, what will be delayed, what's at risk for
                    fees.
                  </Typography>
                </m.div>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </StyledRoot>
  )
}
